import { Typography } from '@bowtie-ins/bowkit';
import { GRAPHITE, ROCK, WHITE } from '@bowtie-ins/bowkit/palette';
import { alpha, Box, ButtonBase, styled } from '@material-ui/core';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

const ATTRIBUTES = [
  {
    title: <FormattedMessage id="variable_attribute.flexi.title" />,
    params: {
      variableAttribute: '',
      productsShow: '1,2',
    },
    value: '',
  },
  {
    title: <FormattedMessage id="variable_attribute.pink.title" />,
    remark: <FormattedMessage id="variable_attribute.pink.remark" />,
    params: {
      variableAttribute: 'deductible',
      productsShow: '0,1,2',
    },
    value: 'deductible',
  },
];

const StyledButtonBase = styled(ButtonBase)(
  ({ active, size }: { active: boolean; size: 'small' | 'large' }) => ({
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '8px 8px 0px 0px',
    backgroundColor: active ? WHITE : alpha(WHITE, 0.5),
    height: size === 'small' ? 56 : 72,
  }),
);

const Button = ({
  title,
  remark,
  active,
  onClick,
  size,
}: {
  title: ReactNode;
  remark?: ReactNode;
  active: boolean;
  onClick: () => void;
  size: 'small' | 'large';
}) => {
  return (
    <StyledButtonBase
      onClick={onClick}
      active={active}
      size={size}
      disableRipple
      disableTouchRipple
    >
      <Box
        display="flex"
        flexDirection={size === 'small' ? 'column' : 'row'}
        gridGap={size === 'small' ? 2 : 10}
        alignItems="center"
      >
        <Typography
          variant={size === 'small' ? 'body-m' : 'title-m'}
          fontWeight="bold"
        >
          {title}
        </Typography>
        {remark && (
          <Box
            px={1}
            borderRadius={4}
            border={`1px solid ${ROCK}`}
            color={GRAPHITE}
          >
            <Typography variant={size === 'small' ? 'body-s' : 'body-m'}>
              {remark}
            </Typography>
          </Box>
        )}
      </Box>
    </StyledButtonBase>
  );
};

const VariableAttributeButtons = ({
  size = 'small',
  variableAttribute,
  onClick,
}: {
  size: 'small' | 'large';
  variableAttribute: string;
  onClick: (params: Record<string, string>) => void;
}) => {
  return (
    <Box
      display="flex"
      gridGap={16}
      flexDirection="row"
      alignItems="flex-end"
      justifyContent="space-between"
    >
      {ATTRIBUTES.map(({ title, remark, params, value }) => (
        <Button
          key={value}
          active={variableAttribute === value}
          onClick={() => onClick(params)}
          title={title}
          remark={remark}
          size={size}
        />
      ))}
    </Box>
  );
};

export default VariableAttributeButtons;
